import type { TagGroup } from './types'
import { isValidGroup } from './predicates'

import type { ConfirmVariant, SfConfirm } from '@app/types'

const makeHandleClick = (
  tagName: string,
  tagGroup: TagGroup
): ((e: Event) => void) => {
  let confirmed = false

  const sfConfirm = window.sfConfirm as SfConfirm<() => void>

  return (e: Event): void => {
    const target = e.target as HTMLLinkElement

    const formattedTagName = `<strong>${tagName}</strong>`

    let question, message, confirmLabel, messageClass
    let confirmVariant: ConfirmVariant | undefined

    if (tagGroup === 'used') {
      //archive strings
      question = window.I18n.t('templates.remark_tag.confirm_archive_title', {
        tag: formattedTagName,
      })
      message = window.I18n.t('templates.remark_tag.confirm_archive_message', {
        tag: tagName,
      })
      confirmLabel = window.I18n.t('templates.remark_tag.confirm_archive_label')

      confirmVariant = 'primary'
      messageClass = 'sf-alert-warning'
    } else if (tagGroup === 'unused') {
      // delete strings
      question = window.I18n.t(
        'js.global_confirmation_modal.combined.warning_html',
        {
          name: formattedTagName,
        }
      )
      confirmLabel = window.I18n.t('templates.remark_tag.confirm_delete_label')

      confirmVariant = 'danger'
      messageClass = 'sf-alert-danger'
    }

    if (!confirmed && tagGroup !== 'archived' && question) {
      e.preventDefault()
      e.stopPropagation()

      sfConfirm({
        question,
        message,
        confirmLabel,
        cancelLabel: window.I18n.t(
          'js.global_confirmation_modal.default.cancel'
        ),
        onConfirm: () => {
          confirmed = true

          if (target.click && typeof target.click === 'function') {
            target.click()
          }
        },
        options: {
          confirm_variant: confirmVariant,
          message_class: messageClass,
        },
      })
    }
  }
}

export default (): (() => void) => {
  const unsubscribers: Array<() => void> = []

  window.onDomLoad(($dom) => {
    const archiveIcons = $dom[0].querySelectorAll(
      "[data-behaviour='remark-tag-archive'] [data-behaviour='archive']"
    )

    archiveIcons.forEach((icon) => {
      const dataset = (icon as HTMLElement).dataset
      const group = dataset?.group

      if (!group || !isValidGroup(group)) {
        return
      }

      const name = dataset?.name || ''

      const callback = makeHandleClick(name, group)
      icon.addEventListener('click', callback)

      unsubscribers.push(() => {
        icon.removeEventListener('click', callback)
      })
    })
  })

  return () => {
    unsubscribers.forEach((unsub) => unsub())
  }
}
